import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

// Verified emails only: the sign-up code, and the signed-in person's own
// email (confirm it, or change / add one with a code to the new address).
const post = (path, data, signedIn = true) =>
  axios({
    method: "post",
    url: `${config.api.base_url}${path}`,
    data,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      ...(signedIn && { Authorization: getToken() }),
    },
  });

export const verifySignUpAPI = (params) => post("auth/sign-up/verify", params, false);
export const resendSignUpCodeAPI = (params) => post("auth/sign-up/resend", params, false);

export const sendEmailCodeAPI = () => post("auth/email/send-code");
export const verifyEmailAPI = (params) => post("auth/email/verify", params);

// params: { newEmail, password } or, without a password, { newEmail, currentCode }
export const changeEmailAPI = (params) => post("auth/email/change", params);
export const resendChangeEmailCodeAPI = () => post("auth/email/change/resend");
export const verifyChangeEmailAPI = (params) => post("auth/email/change/verify", params);
